var angular = require('angular');
var _module = angular.module('benoit');
var _ = require('lodash');

require('../user');
require('../agent-nav-store');
require('../vendor-nav-store');

_module.factory('$brandedNav', [
    '$log',
    '$user',
    '$agentNavStore',
    '$vendorNavStore',

    function ($log, $user, $agentNavStore, $vendorNavStore) {
        function BrandedNav() {
            this.agentNavs = $agentNavStore.navs;
            this.vendorNavs = $vendorNavStore.navs;
            this.agentNavsGrouped = $agentNavStore.grouped_navs;
            this.vendorNavsGrouped = $vendorNavStore.grouped_navs;
            this.showAdditional = {
                meetTheTeam: true,
                featuredProperties: true,
                latestVideos: true,
                contactUs: true
            };
        }

        /*
        Pass in as many item names that
        you want to hide.
        */
        BrandedNav.prototype.hide = function hide() {
            var allowedKeys = Object.keys(this.showAdditional);
            var itemsToHide = _.intersection(allowedKeys, Array.prototype.slice.call(arguments));

            itemsToHide.forEach((function (k) {
                this.showAdditional[k] = false;
            }).bind(this));
        };

        /*
        Pass in as many item names that
        you want to show.
        */
        BrandedNav.prototype.show = function hide() {
            var allowedKeys = Object.keys(this.showAdditional);
            var itemsToHide = _.intersection(allowedKeys, Array.prototype.slice.call(arguments));

            itemsToHide.forEach((function (k) {
                this.showAdditional[k] = true;
            }).bind(this));
        };

        /*
        Allows all the additional nav items
        to be hidden.
        */
        BrandedNav.prototype.hideAll = function showAll() {
            Object.keys(this.showAdditional).forEach((function (k) {
                this.showAdditional[k] = false;
            }).bind(this));
        };

        /*
        Allows all the additional nav items
        to be shown.
        */
        BrandedNav.prototype.showAll = function showAll() {
            Object.keys(this.showAdditional).forEach((function (k) {
                this.showAdditional[k] = true;
            }).bind(this));
        };


        return new BrandedNav();
    }
]);


_module.run([
    '$rootScope',
    '$brandedNav',

    function run($rootScope, $brandedNav) {
        $rootScope.$on('$stateChangeStart', function stateChangeStart() {
            $brandedNav.showAll();
        });
    }
]);
